import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FilterFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M18.22 9.46L13.9 14L13.46 19.8H10.54L10.1 14L5.78 9.46C5 8.64 4.42 7.38 4.42 5.9V4.12H19.58V5.9C19.58 7.38 19 8.64 18.22 9.46Z" />
    </SvgIcon>
  );
});
